import { DEFAULT_STORE_OBJECT } from '../../contants/common';
import RateShopTypes from './RateShopTypes';

const initialState = {
  carriersByCustomer: { ...DEFAULT_STORE_OBJECT, data: [] },
  accessorials: { ...DEFAULT_STORE_OBJECT, data: [] },
  taxList: { ...DEFAULT_STORE_OBJECT, data: [] },
  globalRateShopTab: ['1'],
  activeLaneTab: '0',
  activeLaneStopTab: '0',
  stopsDrawerVisible: false,
  globalMeasurementUnit: false,
  getRateResults: {
    ...DEFAULT_STORE_OBJECT,
    data: {},
    criteria: {},
  },
  selectedCarrierRate: false,
  selectedCargoTypes: [],
  itemsSumValues: { totalPieces: 0, totalWeight: 0 },
};
const RateShopReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case RateShopTypes.GET_CARRIERS_BY_CUSTOMER_PROGRESS: {
      return {
        ...state,
        carriersByCustomer: {
          ...DEFAULT_STORE_OBJECT,
          progressing: true,
          data: [],
        },
      };
    }
    case RateShopTypes.GET_CARRIERS_BY_CUSTOMER_SUCCESS: {
      return {
        ...state,
        carriersByCustomer: {
          ...DEFAULT_STORE_OBJECT,
          success: true,
          ...payload,
        },
      };
    }
    case RateShopTypes.GET_CARRIERS_BY_CUSTOMER_ERROR: {
      return {
        ...state,
        carriersByCustomer: {
          ...DEFAULT_STORE_OBJECT,
          data: [],
          error: true,
          ...payload,
        },
      };
    }

    case RateShopTypes.GET_ACCESSORIALS_LIST_PROGRESS: {
      return {
        ...state,
        accessorials: {
          ...DEFAULT_STORE_OBJECT,
          progressing: true,
          data: [],
        },
      };
    }
    case RateShopTypes.GET_ACCESSORIALS_LIST_SUCCESS: {
      return {
        ...state,
        accessorials: {
          ...DEFAULT_STORE_OBJECT,
          success: true,
          ...payload,
        },
      };
    }
    case RateShopTypes.GET_ACCESSORIALS_LIST_ERROR: {
      return {
        ...state,
        accessorials: {
          ...DEFAULT_STORE_OBJECT,
          data: [],
          error: true,
          ...payload,
        },
      };
    }

    case RateShopTypes.GET_TAX_LIST_PROGRESS: {
      return {
        ...state,
        taxList: {
          ...DEFAULT_STORE_OBJECT,
          progressing: true,
          data: [],
        },
      };
    }
    case RateShopTypes.GET_TAX_LIST_SUCCESS: {
      return {
        ...state,
        taxList: {
          ...DEFAULT_STORE_OBJECT,
          success: true,
          ...payload,
        },
      };
    }
    case RateShopTypes.GET_TAX_LIST_ERROR: {
      return {
        ...state,
        taxList: {
          ...DEFAULT_STORE_OBJECT,
          data: [],
          error: true,
          ...payload,
        },
      };
    }

    case RateShopTypes.SET_GLOBAL_RATE_SHOP_TAB: {
      return {
        ...state,
        globalRateShopTab: payload,
      };
    }

    case RateShopTypes.SET_RATE_SHOP_LANE_TAB: {
      return {
        ...state,
        activeLaneTab: payload,
      };
    }

    case RateShopTypes.SET_RATE_SHOP_LANE_STOP_TAB: {
      return {
        ...state,
        activeLaneStopTab: payload,
      };
    }

    case RateShopTypes.SET_RATE_SHOP_STOPS_DRAWER: {
      return {
        ...state,
        stopsDrawerVisible: payload,
      };
    }

    case RateShopTypes.SET_GLOBAL_RATE_SHOP_MEASUREMENT_UNIT: {
      return {
        ...state,
        globalMeasurementUnit: payload,
      };
    }

    case RateShopTypes.GET_RATE_RESULTS_PROGRESS: {
      return {
        ...state,
        getRateResults: {
          ...DEFAULT_STORE_OBJECT,
          progressing: true,
          data: {},
          criteria: payload,
        },
      };
    }
    case RateShopTypes.GET_RATE_RESULTS_SUCCESS: {
      return {
        ...state,
        getRateResults: {
          ...DEFAULT_STORE_OBJECT,
          success: true,
          criteria: state.getRateResults.criteria,
          ...payload,
        },
      };
    }
    case RateShopTypes.GET_RATE_RESULTS_ERROR: {
      return {
        ...state,
        getRateResults: {
          ...DEFAULT_STORE_OBJECT,
          data: {},
          error: true,
          criteria: state.getRateResults.criteria,
          ...payload,
        },
      };
    }

    case RateShopTypes.SET_SELECTED_CARRIER_RATE: {
      return {
        ...state,
        selectedCarrierRate: payload,
      };
    }

    case RateShopTypes.SET_SELECTED_CARGO_TYPES: {
      return {
        ...state,
        selectedCargoTypes: payload,
      };
    }

    case RateShopTypes.SET_ITEMS_SUM_VALUES: {
      return {
        ...state,
        itemsSumValues: { ...state.itemsSumValues, ...payload },
      };
    }

    default:
      return state;
  }
};

export default RateShopReducer;
